/**
 * 매장 리뷰 조회용 공용 GraphQL 쿼리.
 * store 상세·store 리뷰 전체보기·pack 등에서 사용.
 * @see docs/file-structure.md "공용 gql vs route api"
 */
import { gql } from "../__generated__";

export const GET_REVIEW_BY_STORE_ID = gql(`
  query GetReviewByStoreId($storeId: Int!, $limit: Int, $offset: Int, $orderType: String) {
    getReviewByStoreId(storeId: $storeId, limit: $limit, offset: $offset, orderType: $orderType) {
      id
      user {
        id
        maskedName
      }
      order {
        id
        baseAmount
        amount
      }
      orderType
      reviewImages {
        img
      }
      content
      createdAt
      store {
        title
        img
        area2
        bestReview {
          id
          content
          createdAt
          isBestReview
          storeId
          reviewImages {
            id
            img
            createdAt
            updatedAt
          }
        }
      }
    }
  }
`);
